export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'afd7661c-9a69-489c-8a80-c5d9dc5352a4';
export const MODEL_CLOSE_SEC = 3;
